import {Button, DialogActions, DialogContent} from '@material-ui/core';
import {deleteBeneficiaryPerson} from 'Beneficiaries/ducks/beneficiaryDetail';
import React from 'react';
import {useDispatch} from 'react-redux';
import Modal from 'Shared/components/Modal';

type DeleteBeneficiaryConfirmationModalProps = {
  onClose: () => void;
  policyNumber: string;
  id: string;
};

const DeleteBeneficiaryConfirmationModal = ({onClose, policyNumber, id}: DeleteBeneficiaryConfirmationModalProps) => {
  const dispatch = useDispatch();

  return (
    <Modal title="Delete Beneficiary Person" open onClose={onClose}>
      <div className="card__dialog">
        <DialogContent>Delete Beneficiary Person</DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              dispatch(deleteBeneficiaryPerson(policyNumber, id));
              onClose();
            }}
            color="primary"
          >
            Delete
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </DialogActions>
      </div>
    </Modal>
  );
};

export default DeleteBeneficiaryConfirmationModal;
